import PropTypes from 'prop-types';
import styles from './modal-invest.module.scss';
import { augmentClassName } from '../../../../../utils/GlobalCssProxy';

import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import ModalBasic from '../../../../atoms/modal-basic';
import Icon from '../../../../atoms/icon';

const className = augmentClassName(styles);

const CardInvest = ({ title, buttonTarget, icon, children }) => (
  <div {...className('card', 'bg-white', 'text-black')}>
    <div {...className('card__icon-container', 'text-primary', 'text-right')}>
      {icon}
    </div>
    <div {...className('h4', 'title')}>{title}</div>
    <p {...className('paragraph-standard')}>{children}</p>
    <div {...className('card__button-container')}>
      <Button
        variant={'outline-black'}
        {...className(
          'btn--rounded',
          'font-weight-bold',
          'text-uppercase',
          'font-family-sans-serif'
        )}
        size="sm"
        role="button"
        as="a"
        href={buttonTarget}
        rel="noopener noreferrer"
        target="_blank"
      >
        {title}
      </Button>
    </div>
  </div>
);

CardInvest.propTypes = {
  title: PropTypes.string,
  buttonTarget: PropTypes.string,
  icon: PropTypes.node,
  children: PropTypes.node
};

const ModalInvest = ({ onHide, show, fundNameOrType }) => {

  return (
    <ModalBasic show={show} onHide={onHide} {...className('root')}>
      <ModalBasic.Header>
        <ModalBasic.Title>
          <ModalBasic.Subtitle>Invest in {fundNameOrType}</ModalBasic.Subtitle>
        </ModalBasic.Title>
        <ModalBasic.CloseButton onClick={onHide} />
      </ModalBasic.Header>
      <ModalBasic.Body {...className('body')}>
        <div {...className('row', 'cards')}>
          <Col xs={12} sm={6}>
            <CardInvest
              buttonTarget="https://shared.tiaa.org/private/partmoneymovement/managemymoney/choosetransaction"
              icon={<Icon.Money />}
              title="Login and invest"
            >
              Login to understand your options for investing in {fundNameOrType}.
            </CardInvest>
          </Col>
          <Col xs={12} sm={6}>
            <CardInvest
              title="Open an account"
              icon={<Icon.Certificate />}
              buttonTarget="https://www.tiaa.org/public/invest/financial-products/open-an-account"
            >
              Save more in {fundNameOrType}.
            </CardInvest>
          </Col>
        </div>
      </ModalBasic.Body>
    </ModalBasic>
  );
};

ModalInvest.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool,
  fundNameOrType: PropTypes.string
};

export default ModalInvest;
